import { BuddyFormProps } from "../../BuddyFeedbackForm";
import {
  required,
  requiredSelect,
  validateForm,
  FormErrors,
  ValidationSchema,
  requiredFile,
} from "../validation-engine/ValidationEngine";
import { z } from "zod";

// ─── FormErrors is now just this one line ─────────────────────────────────────
export type BuddyFeedbackErrorProps = FormErrors<BuddyFormProps>;

// Add this map at the top of your schema file
const fieldLabels: Partial<Record<keyof BuddyFeedbackErrorProps, string>> = {
  name: "Name",
  dateOfJoining: "Date of joining",
  buddyName: "Buddy name",
  welcomeOnFirstDay: "Welcomed on first day",
  helpedGelWithTeam: "Helped gel with team",
  buddyResolvedConcerns: "Buddy resolved concerns",
  satisfiedWithBuddy: "Satisfied with buddy",
  knowledgeRating: "Knowledge rating",
  approachabilityRating: "Approachability rating",
  availabilityRating: "Availability rating",
  mostHelpful: "Most helpful aspect",
  couldDoBetter: "Areas for improvement",
  signatureDate: "Signature date",
};

export const buddySchema = z.object({
  name: z.string().min(1, "This field is required"),
  dateOfJoining: z.string().min(1, "This field is required"),
  buddyName: z.string().min(1, "This field is required"),

  welcomeOnFirstDay: z.string().min(1, "This field is required"),
  helpedGelWithTeam: z.string().min(1, "This field is required"),
  buddyResolvedConcerns: z.string().min(1, "This field is required"),
  satisfiedWithBuddy: z.string().min(1, "This field is required"),
  knowledgeRating: z.string().min(1, "This field is required"),
  approachabilityRating: z.string().min(1, "This field is required"),
  availabilityRating: z.string().min(1, "This field is required"),

  mostHelpful: z.string().min(1, "This field is required"),
  couldDoBetter: z.string().min(1, "This field is required"),

  signature: z.instanceof(File, {
    message: "Signature is required",
  }),

  signatureDate: z.string().min(1, "This field is required"),
});

// ============
export const validateBuddyForm = (
  formData: any,
): { errors: BuddyFeedbackErrorProps; firstError: string | null } => {
  const result = buddySchema.safeParse(formData);

  if (result.success) {
    return { errors: {}, firstError: null };
  }

  const errors: Partial<BuddyFeedbackErrorProps> = {};

  result.error.issues.forEach((issue) => {
    const key = issue.path[0] as keyof BuddyFeedbackErrorProps;
    if (!errors[key]) {
      errors[key] = issue.message;
    }
  });

  const firstIssue = result.error.issues[0];
  const firstKey = firstIssue?.path[0] as
    | keyof BuddyFeedbackErrorProps
    | undefined;

  const firstError = firstKey
    ? `${fieldLabels[firstKey] ?? firstKey} is required`
    : null;

  return { errors, firstError };
};

// // ─── Schema ───────────────────────────────────────────────────────────────
// export const buddySchema: ValidationSchema<BuddyFormProps> = {
//   name: [required()],
//   dateOfJoining: [required()],
//   buddyName: [required()],
//   welcomeOnFirstDay: [requiredSelect()],
//   helpedGelWithTeam: [requiredSelect()],
//   buddyResolvedConcerns: [requiredSelect()],
//   satisfiedWithBuddy: [requiredSelect()],
//   knowledgeRating: [requiredSelect()],
//   approachabilityRating: [requiredSelect()],
//   availabilityRating: [requiredSelect()],
//   mostHelpful: [required()],
//   couldDoBetter: [required()],
//   signature: [requiredFile()],
//   signatureDate: [required()],
// };

// // Update only this function, schema stays untouched
// export const validateBuddyForm = (
//   formData: BuddyFormProps,
// ): { errors: BuddyFeedbackErrorProps; firstError: string | null } => {
//   const errors = validateForm(formData, buddySchema);

//   const firstKey = Object.keys(errors)[0] as keyof BuddyFormProps | undefined;
//   const firstError = firstKey
//     ? `${fieldLabels[firstKey] ?? firstKey} is required`
//     : null;

//   return { errors, firstError };
// };
